import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  signal,
} from '@angular/core';
import { JobsService } from '@ups/xplat/api/services';
import { MessageHelper } from '@ups/xplat/web/core';

@Component({
  selector: 'ups-bulk-message-modal',
  templateUrl: 'bulk-message-modal.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkMessageModalComponent {
  @Input() hrRefs: number[] = [];

  @Output() closed: EventEmitter<void> = new EventEmitter();

  // WI 31712: OnPush. Both fields are written only by their [(ngModel)] template bindings,
  // which mark this view dirty, so OnPush cannot leave them stale; they are signals because
  // the template reads them (conventions, OnPush rule 1).
  readonly message = signal('');
  readonly excludeCautionEmployees = signal(true);

  constructor(
    private jobsService: JobsService,
    private msgHelper: MessageHelper
  ) {}

  sendMessage() {
    this.jobsService
      .sendBulkMessage(
        this.hrRefs,
        this.message(),
        this.excludeCautionEmployees()
      )
      .subscribe(() => {
        this.msgHelper.success('Bulk message successfully sent.');
      });

    this.closeModal();
  }

  closeModal() {
    this.closed.emit();
  }
}
